import { combineReducers } from 'redux'
import merge from 'lodash/merge'
import { RECEIVE_GROUPS, RECEIVE_GROUP, RECEIVE_GROUP_USERS } from '../actions/group-actions'
import { RESET_STORE } from '../actions/currentUser-actions'

const searchResults = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_GROUPS:
      return merge([], action.groups, { query: action.query })
    case RESET_STORE:
      return []
    default:
      return state
  }
}

const detail = (state = { group: { group: {}, locations: [] } }, action) => {
  switch (action.type) {
    case RECEIVE_GROUP:
      return { ...state, group: action.group }
    case RESET_STORE:
      return {}
    default:
      return state
  }
}

const users = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_GROUP_USERS:
      return merge([], state, action.users)
    case RESET_STORE:
      return []
    default:
      return state
  }
}

export default combineReducers({
  searchResults,
  detail,
  users,
})
